import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Customer Google-auth calls: send the httpOnly session cookie, plus a
// Bearer fallback for browsers that block cross-site cookies (Safari ITP).
export const authApi = axios.create({ baseURL: API, withCredentials: true });
authApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("bk_auth_token");
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token },
  });
